// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2L6aW","buttons":"styles_buttons__6UlR4"};